<app-successful-payment
  [sendClock]="true"
  title="Ожидайте решение по заявке!"
  [message]="''"
  [subMessages]="['Рассмотрение заявки осуществляется ориентировочно в течение 1 рабочего дня',
      'По итогам принятого решения поступит СМС уведомление']"
  [id]="id"
  [credit]="true"
  (pageCanLeave)="false"
  (cancel)="cancel()"
>
  <div class="note note-warning note-strong">
    Для подтверждения вашего дохода,
    перейдите по ссылке из СМС от METIB_INFO,
    авторизуйтесь на Госуслугахи отправьте согласие
    о передеаче данных. Это займет не более минуты!
  </div>
</app-successful-payment>
